import { makePublishHelper, makeSubscribeHelper } from '../../helpers-creators';

export var commandButtonHide = makePublishHelper('commandButtonHide', 'wh.common.command.ui.header.deposit.limit.button.hide');

export var onCommandButtonHide = makeSubscribeHelper('onCommandButtonHide', 'wh.common.command.ui.header.deposit.limit.button.hide');
//# sourceMappingURL=commandButtonHide.js.map